import { setContext } from 'apollo-link-context';
import { getGraphqlAuthHeaders } from '../utils/authHeaders';

export const accessTokenLink = setContext(() => {
    return {
        headers: getGraphqlAuthHeaders()
    };
});
